module.exports = "query fallbackDetail($id: [QueryArgument]) {\n  entry(id: $id) {\n    typeHandle\n  }\n}"